import { MenuItem, TextField } from "@mui/material";

import type { StoryScopeInfo } from "../useStoryScope";

interface ProjectSelectProps {
  scope: StoryScopeInfo;
  value: number | null;
  onChange: (projectId: number | null) => void;
  label?: string;
}

/**
 * The project a block or layer draws from — folder and organisation-wide
 * stories only (a project story's project is implied, so nothing renders).
 */
export default function ProjectSelect({ scope, value, onChange, label = "Project" }: ProjectSelectProps) {
  if (!scope.isScoped) return null;
  const known = value !== null && scope.byId.has(value);
  return (
    <TextField
      select
      fullWidth
      size="small"
      label={label}
      value={known ? value : ""}
      onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))}
      helperText={
        value !== null && !known ? "This project is no longer in the story's folder. Pick another." : undefined
      }
    >
      <MenuItem value="">Choose a project…</MenuItem>
      {scope.universe.map((project) => (
        <MenuItem key={project.id} value={project.id}>
          {project.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
